import { FIELD_TYPES } from "constants/template-field-type";
import ThemeConfig from "segments/core-configs/theme-config";
import AssetFieldsConfig from "components/core/asset/fields-config";
import FullParagraphFieldsConfig from "segments/desktop/core-components/full-paragraph/fields-config";

const {
  textAlign,
  mobileTextAlign,
  buttonConfig: titleButtonConfig,
  titleColor,
  textColor,
  bodyColor,
  topic,
  ...resOfParagraphConfig
} = FullParagraphFieldsConfig;

export default {
  type: FIELD_TYPES.NESTED,
  label: "Hoverable Cards",
  fields: {
    ...ThemeConfig,
    cards: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Cards",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          defaultHoveredCard: {
            type: FIELD_TYPES.TEXT,
            label: "Default hovered card"
          },
          hoveredColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Hovered color",
            possibleColors: ThemeConfig.theme.possibleColors
          },
          asset: {
            type: FIELD_TYPES.NESTED,
            label: "Asset",
            fields: AssetFieldsConfig
          },
          ...resOfParagraphConfig
        }
      }
    }
  }
};
